var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sky-hc-bulletin-board__item-wrapper"},[_c('h6',{staticClass:"sky-hc-bulletin-board__item-title"},[_vm._v("组织分布情况")]),_c('div',{staticClass:"sky-hc-bulletin-board__pie",attrs:{"id":"pieChart"}})])
}]

export { render, staticRenderFns }